module.exports = __webpack_public_path__ + "static/img/15areaA_5.7b85fc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/15areaA_5.png
// module id = 1014
// module chunks = 1